module.exports = __webpack_public_path__ + "static/media/24UHCHR6.59cc0f18.jpg";